import { render, staticRenderFns } from "./ed-deck-viewer.component.vue?vue&type=template&id=54d0b2d8&scoped=true&"
import script from "./ed-deck-viewer.component.ts?vue&type=script&lang=ts&"
export * from "./ed-deck-viewer.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-deck-viewer.component.scss?vue&type=style&index=0&id=54d0b2d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d0b2d8",
  null
  
)

export default component.exports